
import Vue, { PropType } from 'vue';
import { Runnit, RUNNIT_NODE_DEF_TOOL_TYPE } from '@run-diffusion/shared';
import OfferingCard from '@/components/OfferingCard.vue';
import ManageRunnitMenuBtn from '@/views/Runnits/ManageRunnitMenuBtn.vue';
import RunnitBoardOwnerTableCell from '@/views/Runnits/pages/RunnitBoardsPage/RunnitBoardsDashboard/RunnitBoardOwnerTableCell.vue';

export default Vue.extend({
	name: 'RunnitTemplateTile',
	props: {
		runnit: {
			type: Object as PropType<Runnit>,
			required: true,
		},
		disabled: {
			type: Boolean,
			default: false,
		},
		disabledText: {
			type: String,
			default: null,
		},
		disabledCtaText: {
			type: String,
			default: null,
		},
		disabledCtaProps: {
			type: Object,
			default: () => ({}),
		},
		showEditBtn: {
			type: Boolean,
			default: true,
		},
		editText: {
			type: String,
			default: 'Manage Runnit Template',
		},
		buttonProps: {
			type: Object,
			default: null,
		},
		cardClass: {
			type: String,
			default: 'template-card',
		},
		runnitNodeDef: {
			type: Object,
			default: null,
		},
	},
	data () {
		return {
			RUNNIT_NODE_DEF_TOOL_TYPE,
			isManageRunnitMenuOpen: false,
		};
	},
	components: {
		OfferingCard,
		ManageRunnitMenuBtn,
		RunnitBoardOwnerTableCell,
	},
});
